import { render, staticRenderFns } from "./SchoolOfCreativity.vue?vue&type=template&id=faa609c2&scoped=true&"
import script from "./SchoolOfCreativity.vue?vue&type=script&lang=js&"
export * from "./SchoolOfCreativity.vue?vue&type=script&lang=js&"
import style0 from "./SchoolOfCreativity.vue?vue&type=style&index=0&id=faa609c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa609c2",
  null
  
)

export default component.exports